import React from "react";
import { Link } from "react-router-dom";

import {
  CardElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { MdArrowForwardIos } from "react-icons/md";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function Review({
  nextstep,
  checkoutToken,
  Shippingdata,
  handleCaptureCHeckout,
}) {
  async function handlesubmit(event, elements, stripe) {
    event.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });
    if (error) {
      console.log(error);
    } else {
      const orderData = {
        line_items: checkoutToken.live.line_items,
        customer: {
          firstname: Shippingdata.dataa.firstName,
          lastname: Shippingdata.dataa.lastName,
          email: Shippingdata.dataa.email,
          // tel: Shippingdata.dataa.tel,
        },
        shipping: {
          name: "Primary",
          street: Shippingdata.dataa.address,
          town_city: Shippingdata.dataa.city,
          country_state: Shippingdata.shippingsubdivision,
          postal_zip_code: Shippingdata.dataa.zip,
          country: Shippingdata.shippingcountry,
        },
        fulfillment: { shipping_method: Shippingdata.shippingoption },
        payment: {
          gateway: "stripe",
          stripe: {
            payment_method_id: paymentMethod.id,
          },
        },
      };
      handleCaptureCHeckout(checkoutToken.id, orderData);
      nextstep();
    }
  }
  return (
    <div>
      <div>
        <div className="mt-10">
          <div className="flex  demitablet:flex-col ">
            <div className="w-3/5 tablet:w-[100%]   px-10 demitablet:px-0 ">
              <div className="flex  font-font2  mb-6 py-[30px] border-b-[1px] border-gray-200">
                <h3 className=" text-gray-600 font-medium  pr-32 text-[13px]  uppercase  w-3/5 phonex2:w-4/5  text-left">
                  Products Details
                </h3>
                <h3 className=" phonex2:hidden font-medium text-gray-600 text-center text-[13px] uppercase  w-1/5 ">
                  Quantity
                </h3>
                <h3 className=" text-gray-600 font-medium text-center text-[13px] uppercase  w-1/5 ">
                  Total
                </h3>
              </div>
              <div>
                {checkoutToken.live.line_items.map((product, index) => (
                  <div
                    key={index}
                    className="flex items-center hover:bg-gray-100 hover:shadow-sm rounded-lg "
                  >
                    <div className="flex w-3/5 phonex2:w-4/5 tablet:w-3/5 phone:w-3/5  my-1 items-center ">
                      <img
                        className="h-[80px] md:h-[150px] md:flex-initial  object-cover"
                        src={product.image.url}
                        alt={product.name}
                      />
                      <div className="flex flex-col pl-2 font-bold1 justify-between ">
                        <h1 className="uppercase text-[14px] md:text-xl text-bold font-medium">
                          {product.name}
                        </h1>
                        <p className="text-[14px] md:text-xl">
                          {product.quantity} * 250ml
                        </p>
                        <div className="hidden phonex2:block ">
                          <div className=" bg-primary-100 rounded-full text-white w-6 h-6">
                            <div className="flex justify-center items-center h-6 text-[12px]">
                              {product.quantity}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex phonex2:hidden justify-center items-center   w-1/5 tablet:w-1/5 ">
                      <div className="flex phonex2:flex-col phonex2:justify-center phonex2:items-center phonex2:space-x-0  space-x-5  items-center">
                        <span className="text-[14px] md:text-xl font-bold2">
                          {product.quantity}
                        </span>
                      </div>
                    </div>

                    <div className="flex justify-center w-1/5  font-bold2 text-[14px] md:text-xl">
                      {product.line_total.formatted_with_symbol}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-2/5 tablet:w-full  bg-gray-100 px-10 py-10 phonex2:px-4">
              <Elements stripe={stripePromise}>
                <ElementsConsumer>
                  {({ elements, stripe }) => (
                    <form onSubmit={(e) => handlesubmit(e, elements, stripe)}>
                      <CardElement className="bg-white px-4 py-6 rounded-md" />
                      <br />
                      <br />
                      <div>
                        <button
                          className="bg-primary-100 hover:bg-primary-200 text-white font-font2  text-xl w-full py-4 duration-200 hover:shadow-md rounded-md"
                          type="submit"
                          disabled={!stripe}
                        >
                          <div className="flex justify-between px-10 ">
                            <div>
                              {" "}
                              {
                                checkoutToken.live.subtotal
                                  .formatted_with_symbol
                              }
                            </div>
                            <div className="flex items-center space-x-4">
                              <h2> Pay </h2>
                              <MdArrowForwardIos />
                            </div>
                          </div>
                        </button>
                      </div>
                      <p className="mt-4 bg-primary-100/50 text-[13px] p-4 text-white rounded-md">
                        Please ensure to consistently write the number 42 in
                        order to successfully pass.
                      </p>
                    </form>
                  )}
                </ElementsConsumer>
              </Elements>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Review;
